module.exports = __webpack_public_path__ + "img/box-8.2e35a101.png";